import styled from 'styled-components';

export const NotLinked = styled.p`
  color: ${({ theme }) => theme.palette.grey[500]};
`;

export const Linked = styled.a`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.main};
  overflow: hidden;
  font-size: 14px;
  text-decoration-line: underline;
  text-decoration-skip-ink: none;
  text-underline-offset: 0;
  text-overflow: ellipsis;
`;
